/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type CreateShiftSignupMutationVariables = Types.Exact<{
  data: Types.ShiftSignupCreateInput;
}>;

export type CreateShiftSignupMutation = {
  createShiftSignup: Pick<
    Types.ShiftSignup,
    "event_attendee_id" | "shift_id" | "checked_in"
  >;
};

export const CreateShiftSignupDocument = gql`
  mutation CreateShiftSignup($data: ShiftSignupCreateInput!) {
    createShiftSignup(data: $data) {
      event_attendee_id
      shift_id
      checked_in
    }
  }
`;

/**
 * __useCreateShiftSignupMutation__
 *
 * To run a mutation, you first call `useCreateShiftSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftSignupMutation, { data, loading, error }] = useCreateShiftSignupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateShiftSignupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateShiftSignupMutation,
    CreateShiftSignupMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateShiftSignupMutation,
    CreateShiftSignupMutationVariables
  >(CreateShiftSignupDocument, baseOptions);
}
export type CreateShiftSignupMutationHookResult = ReturnType<
  typeof useCreateShiftSignupMutation
>;
export type CreateShiftSignupMutationResult =
  ApolloReactCommon.MutationResult<CreateShiftSignupMutation>;
export type CreateShiftSignupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateShiftSignupMutation,
    CreateShiftSignupMutationVariables
  >;
